(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  define('app/router/router',['jquery', 'backbone', 'marionette', 'app/views/pipods/pipods', 'app/views/pipods/pipod'], function($, Backbone, Marionette, PipodsView, PipodView) {
    var Router;
    Router = (function(_super) {
      __extends(Router, _super);

      function Router() {
        return Router.__super__.constructor.apply(this, arguments);
      }

      Router.prototype.routes = {
        "venues/:mac_address": "pipod",
        "": "pipods"
      };

      Router.prototype.pipod = function(macAddress) {
        return NowPlaying.mainRegion.show(new PipodView({
          macAddress: macAddress
        }));
      };

      Router.prototype.pipods = function() {
        return NowPlaying.mainRegion.show(new PipodsView());
      };

      Router.prototype.navigateOptions = function() {
        var options;
        return options = {
          trigger: true
        };
      };

      return Router;

    })(Backbone.Router);
    NowPlaying.addInitializer(function(options) {
      NowPlaying.router = new Router();
      return Backbone.history.start();
    });
    return Router;
  });

}).call(this);

//# sourceMappingURL=router.js.map
;
